// import React, { useContext } from 'react'
// import { Link, useNavigate } from 'react-router-dom';
// import Slider from 'react-slick';
// import { useGetAllTopDealsProductByPercentageQuery } from '../services/poductsApi';
// import { useAddCartdetailsMutation, useLazyGetCardDetailsByUseridQuery } from '../services/cartApi';
// import { CartContext } from './CartContext';

// const TopProductSalesOne = () => { 
//     var {isLoading,data}=useGetAllTopDealsProductByPercentageQuery(50)
//     const { addToCart,setCart } = useContext(CartContext);
//     var [addCartfn]=useAddCartdetailsMutation()
//     const navigate = useNavigate();
//     const [getAllCartDetailsfn] = useLazyGetCardDetailsByUseridQuery()

//     const handleAddToCart = async(product) => {
//         if(window.localStorage.getItem('customer_id'))
//         {
//             var customerId=window.localStorage.getItem('customer_id');
//             try {
//                 await addCartfn({
//                     user_id: customerId,
//                     product_id: product.product_id,
//                     unit_id: product.unit_id,
//                     quantity: 1, 
//                 }).unwrap();
//                 const response = await getAllCartDetailsfn(customerId).unwrap(); 
//                 if (response?.data) {
//                     setCart(response.data); 
//                 }
               
//             } catch (error) {
//                 console.error('Error adding to cart:', error?.data || error);
//                 alert('Failed to add product to cart. Please try again.');
//             }
//         }
//         else{
//             addToCart(product);
//         } 
//         navigate('/cart'); // Navigate to cart after adding product
//     };
//     function SampleNextArrow(props) {
//         const { className, onClick } = props;
//         return (
//             <button
//                 type="button" onClick={onClick}
//                 className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
//             >
//                 <i className="ph ph-caret-right" />
//             </button>
//         );
//     }
//     function SamplePrevArrow(props) {
//         const { className, onClick } = props;

//         return (

//             <button
//                 type="button"
//                 onClick={onClick}
//                 className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
//             >
//                 <i className="ph ph-caret-left" />
//             </button>
//         );
//     }
//     const settings = {
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 1000,
//         slidesToShow: 6,
//         slidesToScroll: 1,
//         initialSlide: 0,
//         autoplay: true,
//         nextArrow: <SampleNextArrow />,
//         prevArrow: <SamplePrevArrow />,
//         responsive: [
//             {
//                 breakpoint: 1599,
//                 settings: {
//                     slidesToShow: 6,
//                 },
//             },
//             {
//                 breakpoint: 1399,
//                 settings: {
//                     slidesToShow: 4,
//                 },
//             },
//             {
//                 breakpoint: 992,
//                 settings: {
//                     slidesToShow: 3,
//                 },
//             },
//             {
//                 breakpoint: 575,
//                 settings: {
//                     slidesToShow: 2,
//                 },
//             },
//             {
//                 breakpoint: 424,
//                 settings: {
//                     slidesToShow: 1,
//                 },
//             },
//         ],
//     };
//     return (
//         <section className="organic-food py-80">
//             <div className="container container-lg">
//                 <div className="section-heading">
//                     <div className="flex-between flex-wrap gap-8">
//                         <h5 className="mb-0">Top Savers Today
//                         <span className="product-card__badge bg-warning-700 px-8 py-4 text-lg text-white">
//                                             50%OFF{" "}
//                                         </span></h5>
                        
//                     </div>
//                 </div>
//                 <div className="organic-food__slider arrow-style-two">
//                     <Slider {...settings}>
//                     {
//                             isLoading && <b>Loading...</b>
//                         }
//                         {
//                             !isLoading &&
//                                     data?.data?.map((cat)=>{
//                                         return (
                                        
//                         <div>
                        
//                             <div className="product-card px-8 py-16 border border-warning-700 hover-border-main-600 rounded-16 position-relative transition-2">
//                             <span className="product-card__badge bg-warning-700 px-8 py-4 text-lg text-white">
//                                             50%OFF{" "}
//                                         </span>
//                                 <Link
//                                     to={`/product-details/${cat.product_id}/${cat.unit_id}`}
//                                     className="product-card__thumb flex-center"
//                                 >
//                                     <img src={`${cat.product_img_200}`} alt="" />
//                                 </Link>
//                                 <div className="product-card__content mt-12">
                                   
//                                     <h6 className="title text-lg fw-semibold mt-12 mb-8">
//                                         <Link to={`/product-details/${cat.product_id}/${cat.unit_id}`} className="link text-line-2">
//                                             {cat.product_name}
//                                         </Link>
//                                     </h6>
//                                      <div className="flex-align gap-4">
                                       
//                                     </div> 
//                                     <div className="flex-between gap-8 mt-24 flex-wrap">
//                                         <div className="product-card__price">
//                                             <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
//                                             ₹{cat.mrp}
//                                             </span>
//                                             <span className="text-heading text-md fw-semibold ">
//                                             ₹{cat.sale_price} <span className="text-gray-500 fw-normal">/{cat.unit_value}{cat.unit_type}</span>{" "}
//                                             </span>
//                                         </div>
//                                         <button className="product-card__cart btn bg-success-400 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"onClick={() => handleAddToCart(cat)}>
//                                             Add <i className="ph ph-shopping-cart" /></button>
                                        
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         )
//                     })
//                 }
//                     </Slider>
//                 </div>
//             </div>
//         </section>

//     )
// }

// export default TopProductSalesOne



import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';

import { useGetAllTopDealsProductByPercentageQuery } from '../services/poductsApi';
import {
  useAddCartdetailsMutation,
  useLazyGetCardDetailsByUseridQuery,
} from '../services/cartApi';

import { CartContext } from './CartContext';

const TopProductSalesOne = () => {
  const { isLoading, data } =
    useGetAllTopDealsProductByPercentageQuery(50);

  const { addToCart, setCart } = useContext(CartContext);
  const [addCartfn] = useAddCartdetailsMutation();
  const [getAllCartDetailsfn] =
    useLazyGetCardDetailsByUseridQuery();

  const navigate = useNavigate();

  // ================= ADD TO CART =================
  const handleAddToCart = async (product) => {
    if (window.localStorage.getItem('customer_id')) {
      const customerId =
        window.localStorage.getItem('customer_id');

      try {
        await addCartfn({
          user_id: customerId,
          product_id: product.product_id,
          unit_id: product.unit_id,
          quantity: 1,
        }).unwrap();

        const response =
          await getAllCartDetailsfn(customerId).unwrap();

        if (response?.data) {
          setCart(response.data);
        }
      } catch (error) {
        // console.error('Error adding to cart:', error);
        alert('Failed to add product to cart');
        return;
      }
    } else {
      addToCart(product);
    }

    navigate('/cart');
  };

  // ================= SLIDER ARROWS =================
  const SampleNextArrow = ({ className, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );

  const SamplePrevArrow = ({ className, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );

  // ================= SLIDER SETTINGS =================
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1599, settings: { slidesToShow: 6 } },
      { breakpoint: 1399, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 575, settings: { slidesToShow: 2 } },
      { breakpoint: 424, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="organic-food py-80">
      <div className="container container-lg">

        {/* ================= HEADING ================= */}
        <div className="section-heading mb-24">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">
              Top Savers Today
              <span className="product-card__badge bg-warning-700 px-8 py-4 text-sm text-white ml-8">
                50% OFF
              </span>
            </h5>
          </div>
        </div>

        {/* ================= SLIDER ================= */}
        <div className="organic-food__slider arrow-style-two">
          <Slider {...settings}>

            {isLoading && <div>Loading...</div>}

            {!isLoading &&
              data?.data?.map((cat) => (
                <div key={`${cat.product_id}-${cat.unit_id}`}>
                  <div className="product-card px-12 py-16 border border-warning-700 hover-border-main-600 rounded-16 position-relative transition-2 h-100">

                    {/* ============ HEADER ============ */}
                    <div className="product-card__header position-relative">
                      <span className="product-card__badge bg-warning-700 px-8 py-4 text-sm text-white position-absolute top-0 start-0">
                        50% OFF
                      </span>

                      <Link
                        to={`/product-details/${cat.product_id}/${cat.unit_id}`}
                        className="product-card__thumb flex-center"
                      >
                        <img
                          src={cat.product_img_200}
                          alt={cat.product_name}
                          className="img-fluid"
                        />
                      </Link>
                    </div>

                    {/* ============ BODY ============ */}
                    <div className="product-card__body mt-12 text-center">
                      <h6 className="title text-md fw-semibold mb-0">
                        <Link
                          to={`/product-details/${cat.product_id}/${cat.unit_id}`}
                          className="link text-line-2"
                        >
                          {cat.product_name}
                        </Link>
                      </h6>
                    </div>

                    {/* ============ FOOTER ============ */}
                    <div className="product-card__footer mt-20">
                      <div className="flex-between gap-8 flex-wrap">
                        <div className="product-card__price">
                          <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through d-block">
                            ₹{cat.mrp}
                          </span>

                          <span className="text-heading text-md fw-semibold">
                            ₹{cat.sale_price}
                            <span className="text-gray-500 fw-normal">
                              /{cat.unit_value}
                              {cat.unit_type}
                            </span>
                          </span>
                        </div>

                        <button
                          className="product-card__cart btn bg-success-400 text-main-600 hover-bg-main-600 hover-text-white py-10 px-20 rounded-pill flex-align gap-8"
                          onClick={() => handleAddToCart(cat)}
                        >
                          Add <i className="ph ph-shopping-cart" />
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              ))}

          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TopProductSalesOne;
